import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	getMdjYStastic: ({ searchParams }) => {
		let queryStr = objectToQuerystring({
			partType: searchParams.partType, 
			searchDate: searchParams.searchDate
		});
		return client
			.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/mdjYStatistic` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
